<template>
<v-app>
<v-form>
<form name="loginform-custom" id="loginform-custom" action="/wp-login.php" method="post">

    <v-text-field
      label="Benutzername"
      id="user_login"
      name="log"
      prepend-icon="fa-user"
      outlined
      type="email"
      required
    ></v-text-field>

    <v-text-field
      id="user_pass"
      label="Passwort"
      name="pwd"
      prepend-icon="fa-lock-alt"
      outlined
      required
      type="password"
    ></v-text-field>

    <v-checkbox name="rememberme" value="forever" label="Angemeldet bleiben"></v-checkbox>

    <button type="submit" class="btn btn-primary">Anmelden</button>
    <input type="hidden" name="redirect_to" value="/login/">
</form>
</v-form>
</v-app>
</template>

<script>
export default {
  name: "LoginApp",

  components: {
  },

  data() {
  }
};
</script>
